export default __webpack_public_path__ + "static/media/count3.b2a08743.png";